module.exports = __webpack_public_path__ + "static/media/gitTogether-details2.839eccc0.png";